export default {
  baseApi: "https://api.branduniverse.com.br",
  colors: {
    primary: "#00BEB2",
    titles: "#4A4A49",
  },
};
